export const fileUriToURl = (uri)=>{
	    if(uri.match(/^public:\/\//)){

                //return 'https://cdn.taxihaarlemservice.nl/'+encodeURIComponent(uri.slice(9))    
                return 'https://storage.googleapis.com/taxi-haarlem/'+uri.slice(9)    
            }
            return false
}

export const wbrConvert=s=>typeof s==='string'?s.replace(/<wbr>/gi,"\u00AD"):s